/*** IMPORTS FROM imports-loader ***/
(function() {
var app = window.app||{};
var define = false;
var exports = false;
var module = undefined;

var app = app || {};

(function () {
  'use strict';

  /**
   * Форма заказа
   */
  app.JpOrder = app.Model.extend({

    /**
     * статус "Товар зарезервирован у поставщика"
     */
    JP_ORDER_STATUS_RESERVED: 7,

    /**
     * статус "Подтверждена организатором"
     */
    JP_ORDER_STATUS_CONFIRMED: 8,

    urlRoot: app.entryScriptName + '/api/v3/jp-order',

    url: function () {
      return this.urlRoot + '/' + this.get('id') + '/?expand=jp_order_status';
    },

    /**
     * Отмена заявки
     * Смена статуса заказа и отправка причины отмены
     * @param data {Object} данные причины отмены
     * @param options {Object} опции
     */
    cancelJPOrder: function (data, options) {
      if (!data){
        return;
      }

      if (options && options.userType === 'organizer') {
        data.jp_order_status_id = 2;
      } else {
        data.jp_order_status_id = 9;
      }
      options.wait = true;
      return this.save(data, options);
    }
  });
})();

}.call(window));